export default "__VITE_ASSET__53540f7b__"